import {useCallback} from "react";
import {toast} from "react-toastify";

const useToast = () => {
  const showToastError = useCallback(text => toast.error(text), []);

  const showToastSuccess = useCallback(text => toast.success(text), []);

  return {
    showToastError,
    showToastSuccess
  }
};

export default useToast;
